import React, { memo, useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import Switch from 'react-switch';
import TaetigkeitsberichtReportEmployeeTable from '../Components/Taetigkeitsbericht/TaetigkeitsberichtReportEmployeeTable';
import Auftraggeber from '../Components/Taetigkeitsbericht/Auftraggeber';
import Wetter from '../Components/Taetigkeitsbericht/Wetter';
import Geraete from '../Components/Taetigkeitsbericht/Geraete';
import TaetigkeitsberichtActionButtonsComponent from '../Components/Taetigkeitsbericht/TaetigkeitsberichtActionButtonsComponent';
import Material from '../Components/Taetigkeitsbericht/Material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock, faPenSquare } from '@fortawesome/free-solid-svg-icons';
import TaetigkeitsberichtHeadings from '../Components/Taetigkeitsbericht/TaetigkeitsberichtHeadings';
import Signature from '../Components/Taetigkeitsbericht/Signature';
import {getprojectandmetadata, getToken} from '../Utils/Common';
import TagesTaetigkeitVerortung from '../Components/TagesTaetigkeitVerortung';
import Storung from "../Components/Taetigkeitsbericht/Storung";

function TaetigkeitsberichtPage({ history }) {
    let tID = history.location.state.dataID;
    let [tstatus, settstatus] = useState(history.location.state.tstatus);


    const [taetigkeitsberichtMetaData, setTaetigkeitsberichtMetaData] = useState({
        id: 1,
        projectID: 'PROJECT001',
        organisationID: 'ORG001',
        taetigkeitsberichtDataID: 'TD001',
        creatorName: 'Name 1',
        creatorFirstName: 'F Name 1',
        creatorLastName: 'L Name 1',
        status: 'offen',
        date: '15.11.2022',
        approvalData: {
            approvalFirstName: 'First Name 1',
            approvalLastName: 'Last Name 1',
            approvalDate: '16.11.2022'
        }
    });
    const [projectData,setProjectData]=useState([])
    const [taetigkeitsberichtData, setTaetigkeitsberichtData] = useState({});
    const [originState, setOriginState] = useState(true);

    const [orgTD, setOrgTD] = useState({});
    const [revTD, setRevTD] = useState({});

    const [pID, setPID] = useState(sessionStorage.getItem('projectID'));

    const [isChange, setIsChange] = useState(false);

    function handleChange(checked) {
        setOriginState(checked);
    }

    useEffect(() => {
        let apiBody = {
            token: getToken(),
            data: {
                taetigkeitsberichtDataID: tID
            }
        };

        async function getTData() {
            let response = await fetch(
                process.env.REACT_APP_BACKEND_API_URI + 'mobileappbackend/gettaetigkeitsberichtreport',
                {
                    //let response = await fetch("https://yv3616bv8b.execute-api.eu-west-3.amazonaws.com/dev/v1/app/gettaetigkeitsberichtreport", {
                    method: 'POST',
                    headers: {
                        'Content-type': 'application/json'
                    },
                    body: JSON.stringify(apiBody)
                }
            );

            let data = await response.json();
            setTaetigkeitsberichtData(data.taetigkeitsberichtorg);
            setOrgTD(data.taetigkeitsberichtorg);
            setRevTD(data.taetigkeitsberichtrev);

            setPID(data.taetigkeitsberichtrev.projectID);
        }

        getTData().then((r) => r);
    }, []);

    useEffect(() => {}, [taetigkeitsberichtData]);

    useEffect(async() => {
        let apiBody = {
            token: getToken(),
            data: {
                dataID: tID
            }
        };
        let data = await getprojectandmetadata(apiBody)
        setTaetigkeitsberichtMetaData(data.meta_data);
        setProjectData(data.proj_data);
    }, []);

    useEffect(() => {
        if (originState === false) {
            setTaetigkeitsberichtData(revTD);
            console.log(revTD);
        } else {
            console.log(orgTD);
            setTaetigkeitsberichtData(orgTD);
        }
    }, [originState]);

    useEffect(() => {}, [orgTD, revTD]);

    return (
        <div className="handwai-dark">
            <div
                style={{
                    width: '100%'

                }}
            >
                <Row className="handwai-text-label-normal">
                    <Col />
                    <Col />
                    <Col />
                    <Col>
                        <br />

                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                height: '100%'
                            }}
                        >
                            <FontAwesomeIcon
                                icon={faLock}
                                style={{
                                    fontSize: '24px',
                                    color: originState ? '#1abc9c' : '#7c7c7c'
                                }}
                            />
                            &nbsp;
                            <Switch
                                onChange={handleChange}
                                checked={originState}
                                onColor="#1abc9c"
                                offColor="#1abc9c"
                                onHandleColor="#7c7c7c"
                                offHandleColor="#7c7c7c"
                                handleDiameter={30}
                                uncheckedIcon={false}
                                checkedIcon={false}
                                boxShadow="0px 1px 1x rgba(0, 0, 0)"
                                activeBoxShadow="0px 0px 1px rgba(0, 0, 0)"
                                height={20}
                                width={48}
                            />{' '}
                            &nbsp;
                            <FontAwesomeIcon
                                icon={faPenSquare}
                                style={{
                                    fontSize: '24px',
                                    color: originState ? '#7c7c7c' : '#1abc9c'
                                }}
                            />
                        </div>
                    </Col>
                </Row>
                {taetigkeitsberichtMetaData.id !== undefined && (
                    <TaetigkeitsberichtHeadings taetigkeitsberichtMetaData={taetigkeitsberichtMetaData} />
                )}
                <br />
                <br />
                <Row>
                    <Col />
                    <Col sm={5}>
                        {taetigkeitsberichtData?.coworkers !== undefined && (
                            <TaetigkeitsberichtReportEmployeeTable
                                tstatus={tstatus}
                                setIsChange={setIsChange}
                                originState={originState}
                                tEmployeeData={taetigkeitsberichtData.coworkers}
                                defaultStartTime={taetigkeitsberichtData.coworkers[0]?.workHours.startTime}
                                defaultEndTime={taetigkeitsberichtData.coworkers[0]?.workHours.endTime}
                            />
                        )}
                    </Col>
                    <Col />
                    <Col sm={3}>
                        <Auftraggeber
                            tstatus={tstatus}
                            setIsChange={setIsChange}
                            pID={pID}
                            originState={originState}
                            auftraggeberData={taetigkeitsberichtData?.auftraggeber}
                        />
                    </Col>
                    <Col />
                    <Col sm={2}>
                        <Wetter
                            setIsChange={setIsChange}
                            originState={originState ||tstatus==="Akzeptiert"}
                            wetterData={taetigkeitsberichtData?.wetter}
                        />
                    </Col>
                    <Col />
                </Row>
                <br />
                <Row>
                    <Col />
                    <Col sm={4}>
                        <label className="handwai-text-label-main">{'Tätigkeit'}</label>
                    </Col>
                    <Col sm={7}></Col>
                    <Col />
                </Row>
                <br />

                <TagesTaetigkeitVerortung
                    tstatus={tstatus}
                    setIsChange={setIsChange}
                    setTaetigkeitsberichtData={setTaetigkeitsberichtData}
                    originState={originState}
                    taetigkeitsberichtData={taetigkeitsberichtData}
                />
                <br /> <br />
                <br /> <br />
                <Row>
                    <Col />
                    <Col sm={7}>
                        <Material
                            taetigkeitsberichtData={taetigkeitsberichtData}
                            setTaetigkeitsberichtData={setTaetigkeitsberichtData}
                            materialData={taetigkeitsberichtData.material}
                            setIsChange={setIsChange}
                            originState={originState}
                            tstatus={tstatus}

                        />
                    </Col>
                    <Col sm={4}>
                        <Geraete
                            tstatus={tstatus}
                            setIsChange={setIsChange}
                            originState={originState}
                            geraeteData={taetigkeitsberichtData?.device}
                        />
                    </Col>
                    <Col />
                </Row>
                <br /> <br />

                <Row>
                    <Col />
                    <Col sm={4}>
                        <Storung
                            storung={taetigkeitsberichtData?.stoerung}
                        />
                    </Col>
                    <Col sm={7}>

                    </Col>
                    <Col />
                </Row>
                <br /> <br />


                <Row>
                    <Col />
                    <Col sm={7}>
                        {taetigkeitsberichtData?.coworkers !== undefined && (
                            <Signature
                                type={'creatorSign'}
                                name={
                                    taetigkeitsberichtData?.coworkers[0]?.firstName +
                                    ' ' +
                                    taetigkeitsberichtData?.coworkers[0]?.lastName
                                }
                                image={taetigkeitsberichtData?.creatorSignature}
                            />
                        )}
                    </Col>

                    <Col sm={4}></Col>
                    <Col />
                </Row>
            </div>

            <br />

            <div className="horizontal-line"></div>
            <div
                style={{
                    width: '100%'
                }}
            >
                <TaetigkeitsberichtActionButtonsComponent
                    projectData={projectData}
                    tstatus={tstatus}
                    settstatus={settstatus}
                    isChange={isChange}
                    setIsChange={setIsChange}
                    originState={originState}
                    taetigkeitsberichtData={taetigkeitsberichtData}
                    taetigkeitsberichtMetaData={taetigkeitsberichtMetaData}
                    type={history.location.state.type}
                />
            </div>
            <br />
        </div>
    );
}

export default memo(TaetigkeitsberichtPage);
